module.exports = __webpack_public_path__ + "static/media/shortness_of_breath.aeee1a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms/shortness_of_breath.png
// module id = 415
// module chunks = 0